import { render, staticRenderFns } from "./SelectStudyCategoryMainPanel.vue?vue&type=template&id=84c298f2&scoped=true&lang=pug&"
import script from "./SelectStudyCategoryMainPanel.vue?vue&type=script&lang=ts&"
export * from "./SelectStudyCategoryMainPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SelectStudyCategoryMainPanel.vue?vue&type=style&index=0&id=84c298f2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c298f2",
  null
  
)

export default component.exports